export enum TargetForwardType {
  Chat = 'chat',
  Channel = 'channel',
  Contact = 'contact',
}
